import { useState } from 'react'
import Base64 from '../components/base64Convert/Base64'
const UploadFile = () => {
  const [fileURL, setFileURL] = useState("");
  const [fileName, setFileName] = useState("");
  const [remove, setRemove] = useState("");
  const onChangeFile = async event => {
    const file = event.target.files[0];
    const fileName = event.target.files[0];
    const convertBase64File = await Base64(file)
    await setFileURL(convertBase64File)
    await setFileName(fileName);
    const removeId = event.target.id;
    await setRemove(removeId);
  }

  const removeFile = (event) => {
    setFileURL("");
    setFileName("");
    document.getElementById(`${remove}`).value = "";
  }

  return { fileURL, fileName, onChangeFile, removeFile, setFileURL }

}

export default UploadFile